import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import { ProgressBar } from "primereact/progressbar";
function Home() {
    const [loading, setLoading] = useState(true);

    useEffect(()=> {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1500);
        return () => clearTimeout(timer);
    }, [])
    const quotes = [
        "Success is the sum of small efforts repeated every day.",
        "Learning never exhausts the mind.",
        "Great things are done by a series of small things brought together",
        "Believe you can and you're halfway there."
    ];
    return (
        <>
        {loading && (
            // <div style={{height:"100vh", display:"flex", justifyContent:"center",alignItems:"center", backgroundColor: "#f4fbfb"}}>
            //     <ProgressSpinner />
            // </div>
            <div style={{height:"100vh", display:"flex", justifyContent:"center",alignItems:"center", backgroundColor: "#f4fbfb"}}>
                <div style={{width:"500px"}}>
                 <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
                 </div>
             </div>
        )}
        <div style={{backgroundColor: "#f4fbfd", minHeight: "100vh", padding: "40px", display:"flex", justifyContent:"center", alignItems: "center"}}>
            <Card style={{width:"600px", textAlign:"center"}}>
                <h1 style={{color:"#007ad9"}}>Radix Book App</h1>
                <h2 style={{marginTop:"20px", color:"#34495e"}}>Welcome</h2>
                <h3 style={{marginTop:"30px", color:"#007ad9"}}>Quote of the Day</h3>
                {quotes.map((quote, index)=>(
                    <p key={index} style={{fontStyle:"italic",color:"#555"}}>"{quote}"</p>
                ))}
            </Card>
        </div>
        </>
    )
}
export default Home;